var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoiClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "166px",
    viewBox: "0 0 166 166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    fill: "#2787CC",
    stroke: "#FFFFFF",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 77,
    cy: 77,
    r: 77
  })), /*#__PURE__*/React.createElement("g", {
    id: "store_black_24dp",
    transform: "translate(41.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 72 0 72 72 0 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,18 L57,18 C58.65,18 60,16.65 60,15 C60,13.35 58.65,12 57,12 L15,12 C13.35,12 12,13.35 12,15 C12,16.65 13.35,18 15,18 Z M60.48,23.4 C60.21,22.02 58.98,21 57.54,21 L14.46,21 C13.02,21 11.79,22.02 11.52,23.4 L8.52,38.4 C8.16,40.26 9.57,42 11.46,42 L12,42 L12,57 C12,58.65 13.35,60 15,60 L39,60 C40.65,60 42,58.65 42,57 L42,42 L54,42 L54,57 C54,58.65 55.35,60 57,60 C58.65,60 60,58.65 60,57 L60,42 L60.54,42 C62.43,42 63.84,40.26 63.48,38.4 L60.48,23.4 Z M36,54 L18,54 L18,42 L36,42 L36,54 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiClient);
export default __webpack_public_path__ + "static/media/poi-client.634a85b888e57bc9a029e472587d9b2f.svg";
export { ForwardRef as ReactComponent };